import { render, staticRenderFns } from "./Hints.vue?vue&type=template&id=5fc6e09a&scoped=true"
import script from "./Hints.vue?vue&type=script&lang=ts"
export * from "./Hints.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc6e09a",
  null
  
)

export default component.exports